<div class="tournament-tab" [class.tournament-fullscreen]="isFullScreen">

  <!-- Toolbar -->
  <div class="tab-toolbar">
    <button class="toolbar-btn compare-btn" (click)="toggleCompare()">
      <span *ngIf="!compareOpen">&#x2696; Compare</span>
      <span *ngIf="compareOpen">&#x2715; Close Compare</span>
    </button>

    <!-- Switch button: always visible when comparing; on small screens it hides the inactive panel -->
    <button *ngIf="compareOpen" class="toolbar-btn switch-btn" (click)="switchPanel()" title="Switch focus between panels">
      <span *ngIf="activePanelIndex === 0">Compare &#x25B6;</span>
      <span *ngIf="activePanelIndex === 1">&#x25C4; Primary</span>
    </button>

    <button class="toolbar-btn fullscreen-btn" (click)="toggleFullScreen()" [title]="isFullScreen ? 'Exit full screen' : 'Full screen'">
      <span *ngIf="!isFullScreen">&#x26F6;</span>
      <span *ngIf="isFullScreen">&#x2715;</span>
    </button>
  </div>

  <!-- Panel pips: show active indicator on small screens -->
  <div class="panel-pips" *ngIf="compareOpen">
    <span class="panel-pip" [class.active]="activePanelIndex === 0" (click)="activePanelIndex = 0" title="Primary">1</span>
    <span class="panel-pip" [class.active]="activePanelIndex === 1" (click)="activePanelIndex = 1" title="Compare">2</span>
  </div>

  <!-- Panel layout -->
  <div class="compare-layout" [class.split]="compareOpen">

    <app-tournament-panel
      [class.panel-inactive]="compareOpen && activePanelIndex !== 0"
      [session]="session"
      [details]="details"
      [sharedFavorites]="tournFavoriteFleets"
      [peerData]="compareData"
      [peerForecastData]="compareForecastData"
      (favoriteToggled)="onFavoriteToggled($event)"
      (tournamentDataChanged)="onPrimaryDataChanged($event)"
      (forecastDataChanged)="onPrimaryForecastChanged($event)"
      (projectionRequested)="onPrimaryProjectionRequested($event)">
    </app-tournament-panel>

    <app-tournament-panel *ngIf="compareOpen"
      [class.panel-inactive]="activePanelIndex !== 1"
      [session]="session"
      [details]="null"
      [sharedFavorites]="tournFavoriteFleets"
      [peerData]="primaryData"
      [peerForecastData]="primaryForecastData"
      (favoriteToggled)="onFavoriteToggled($event)"
      (tournamentDataChanged)="onCompareDataChanged($event)"
      [isComparePanel]="true"
      [initialBacktest]="compareInitialBacktest"
      (forecastDataChanged)="onCompareForecastChanged($event)">
    </app-tournament-panel>

  </div>

</div>
